export const CORES = { entrada: "#059669", saida: "#dc2626", saldo: "#3b82f6" };

export const reais = (v) => (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
/** Eixo do gráfico: curto para caber numa linha ("3,5k", "-12k", "1,2mi"). */
export const compacto = (v) => {
  const n = Math.abs(Number(v) || 0);
  const s = n >= 1e6 ? `${(n / 1e6).toFixed(1)}mi` : n >= 1e3 ? `${(n / 1e3).toFixed(n >= 1e4 ? 0 : 1)}k` : n.toFixed(0);
  return `${v < 0 ? "-" : ""}${s.replace(".", ",").replace(",0k", "k").replace(",0mi", "mi")}`;
};
const MESES = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];
export const dataCurta = (iso) => { const [, m, d] = iso.split("-"); return `${d}/${m}`; };
export const dataLonga = (iso) => { const [a, m, d] = iso.split("-"); return `${d}/${m}/${a}`; };
export const diaSemana = (iso) => ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"][new Date(`${iso}T12:00:00`).getDay()];

/** Rótulo do grupo do gráfico/tabela conforme o agrupamento. */
export function rotuloGrupo(iso, agrupar) {
  if (agrupar === "mes") { const [a, m] = iso.split("-"); return `${MESES[+m - 1]}/${a.slice(2)}`; }
  if (agrupar === "semana") {
    const fim = new Date(`${iso}T12:00:00`); fim.setDate(fim.getDate() + 6);
    return `${dataCurta(iso)}–${String(fim.getDate()).padStart(2, "0")}/${String(fim.getMonth() + 1).padStart(2, "0")}`;
  }
  return dataCurta(iso);
}
